import { Component, OnInit, TemplateRef } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router, Params, ActivatedRoute } from '@angular/router';
import { ProviderService } from './../provider.service';
import { Provider } from './../provider.model';
import { sortBy, get, lowerCase, includes, chain } from 'lodash';
import { BsModalService } from 'ngx-bootstrap';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { unescape } from 'lodash';
import { Encoder } from '../../../utils/encoder';

@Component({
  selector: 'app-provider',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.scss']
})
export class ProviderFormComponent implements OnInit {
  providerForm: FormGroup;
  id: FormControl;
  name: FormControl;
  region: FormControl;
  bu: FormControl;
  country: FormControl;
  party: FormControl;
  description: FormControl;
  modalRef: BsModalRef;
  deleteModalRef: BsModalRef;
  regionDatas: Array<any>;
  buDatas: Array<any>;
  countryDatas: Array<any>;

  regionValue: string;
  buValue: string;
  countryValue: string;

  regionList: Array<string>;
  countryList: Array<string>;
  buList: Array<string>;
  partyList: Array<string>;

  showAlert = false;
  errorMessage: string = null;

  provider: Provider = new Provider();
  isEditing: boolean;
  loading: boolean = false;
  descriptionValidate: boolean = false;


  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private providerService: ProviderService,
    private modalService: BsModalService
  ) { }

  ngOnInit() {
    this.createFormControls();
    this.createForm();
    this.id.disable();
    this.providerService.hasJustRegistered = false;

    const data = get(this.activatedRoute, ['snapshot', 'data'], {});

    this.partyList = this.getPartiesList();

    this.party.setValue(this.partyList[0]);
    // If have a providerName param is a provider edition
    // @ts-ignore
    this.isEditing = !!data.provider;

    if (this.isEditing) {
      this.region.disable();
      this.bu.disable();
      this.country.disable();
      this.name.disable();
      // @ts-ignore
      this.provider = data.provider;
      if (this.provider.hasOwnProperty('providerId')) {
        this.provider.providerName = Encoder.decode(this.provider.providerName);
        this.provider.providerDesc = Encoder.decode(this.provider.providerDesc);

        this.name.setValue(this.provider.providerName);
        this.description.setValue(this.provider.providerDesc);
        this.id.setValue(this.provider.providerId);
        this.party.setValue(this.provider.providerParty);
      } else {
        this.router.navigate(['/providers']);
      }
    }

    this.providerService.getRegionList()
      .subscribe((regions) => {
        this.regionDatas = regions;
        this.region.setValue(this.regionDatas[0].code);
        this.onChangeRegion(0);
        if (this.isEditing) {
          this.setChainedOptionsValue();
        }
      });
  }

  setChainedOptionsValue() {
    this.region.setValue(this.provider.region);
    this.bu.setValue(this.provider.bu);
    this.country.setValue(this.provider.country);
    this.regionDatas.forEach((region, index) => {
      if (region.code == this.provider.region) {
        this.buDatas = this.regionDatas[index].bu;
        this.buDatas.forEach((bu, buIndex) => {
          if (bu.code == this.provider.bu) {
            this.countryDatas = this.buDatas[buIndex].country;
          }
        });
      }
    });
  }

  private getPartiesList(): Array<string> {
    return get(this.activatedRoute, ['snapshot', 'data', 'parties'], []);
  }

  createFormControls() {
    this.id = new FormControl('');
    this.name = new FormControl('', {
      validators: Validators.required
    });
    this.region = new FormControl('', {
      validators: Validators.required
    });
    this.bu = new FormControl('', {
      validators: Validators.required
    });
    this.country = new FormControl('', {
      validators: Validators.required
    });
    this.party = new FormControl('', {
      validators: Validators.required
    });
    this.description = new FormControl('', {
      validators: Validators.required
    });
  }

  createForm() {
    this.providerForm = new FormGroup({
      id: this.id,
      name: this.name,
      region: this.region,
      bu: this.bu,
      country: this.country,
      party: this.party,
      description: this.description
    });
  }

  providerSubmit(template: TemplateRef<any>): any {
    this.dirtyForm(this.providerForm);
    const provider = new Provider(
      null,
      Encoder.encode(this.name.value),
      this.party.value,
      this.region.value,
      Encoder.encode(this.description.value),
      this.country.value,
      this.bu.value,
      Math.floor(Date.now() / 1000)
    );

    this.descriptionValidate = this.checkHtml(this.description.value);

    if (this.descriptionValidate) return null
    if (this.providerForm.valid) {
      this.loading = true;
      if (!this.isEditing) {
        this.providerService.saveProvider(provider)
          .subscribe(res => {
            this.loading = false;
            this.modalRef = this.modalService.show(template, {
              ignoreBackdropClick: true
            });
          }, error => {
            this.loading = false;
            this.showAlert = true;
            this.errorMessage = error;
          });
      } else {
        this.activatedRoute.params.subscribe(value => {
          provider.providerId = value.providerId;
        })
        provider.createTime = Math.floor(this.provider.createTime / 1);
        this.providerService.updateProvider(provider)
          .subscribe(res => {
            this.loading = false;
            this.router.navigate(['/providers']);
          }, error => {
            this.loading = false;
            this.showAlert = true;
            this.errorMessage = error;
          });
      }
    }
  }

  deleteShowModal(template: TemplateRef<any>): any {
    this.deleteModalRef = this.modalService.show(template, {
      ignoreBackdropClick: true
    });
  }

  deleteConfirm() {
    this.activatedRoute.params.subscribe(value => {
      this.loading = true;
      this.providerService.deleteProviderById(value.providerId).subscribe(res => {
        this.loading = false;
        this.router.navigate(['/providers']);
        this.deleteModalRef.hide()
      }, error => {
        this.loading = false;
        this.deleteModalRef.hide()
        this.showAlert = true;
        this.errorMessage = error;
      });
    })
  }

  onChangeRegion(regionIndex: any) {
    this.buDatas = this.regionDatas[regionIndex].bu;
    this.bu.setValue(this.buDatas[0].code);
    this.onChangeBu(0);
  }

  onChangeBu(buIndex: number) {
    this.countryDatas = this.buDatas[buIndex].country;
    this.country.setValue(this.countryDatas[0].code);
    this.onChangeCountry(0);
  }

  onChangeCountry(countryIndex: number) {
  }

  errorMessageClose(): void {
    this.showAlert = false;
    this.errorMessage = '';
  }

  private dirtyForm(form: FormGroup) {
    Object.keys(form.controls).forEach(key => {
      const control = form.controls[key];

      if (control instanceof FormGroup) {
        return this.dirtyForm(control);
      }

      control.markAsDirty();
    });
  }

  redirectTo(uri: string) {
    this.router.navigateByUrl('/', { skipLocationChange: true })
      .then(() =>
        this.router.navigate([uri]));
  }

  checkHtml (htmlStr: string) {
    let reg = /<[^>]+>/g;
    return reg.test(htmlStr);
  }

  checkInputValue (e) {
    return this[e.target.id].value = e.target.value = e.target.value.replace(/[^a-zA-Z0-9_\- ]||/g,'');
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/provider/form/form.component.ts